export default __webpack_public_path__ + "static/media/SEDAN.51f2bf47.png";